import { useNavigate } from 'react-router-dom'
import { FiChevronLeft } from 'react-icons/fi'
import { useTranslation } from 'react-i18next'

interface Props {
  marginBottom?: string
  onClickHandler?: () => void
  // 'icon' is the compact circular control used on the organisation detail
  // header; 'text' keeps the labelled button the other pages use.
  variant?: 'text' | 'icon'
}

const BackBtn = ({
  marginBottom = 'mb-0',
  onClickHandler,
  variant = 'text',
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleClick = onClickHandler ? onClickHandler : () => navigate(-1)

  if (variant === 'icon') {
    return (
      <button
        type='button'
        onClick={handleClick}
        aria-label={t('back')}
        className={`bg-white shadow-header rounded-lg w-9 h-9 flex items-center justify-center cursor-pointer hover:bg-mainBg transition-colors print:hidden ${marginBottom}`}
      >
        <FiChevronLeft className='text-lg text-primaryBlue' />
      </button>
    )
  }

  return (
    <button
      type='button'
      onClick={handleClick}
      className={`bg-transparent w-max flex items-center text-sm font-medium text-[#3E3E3E] gap-[1px] cursor-pointer print:hidden ${marginBottom}`}
    >
      <FiChevronLeft className='text-lg text-[#3E3E3E]' />
      {t('back')}
    </button>
  )
}

export default BackBtn
